<template>
  <div class="copyright">
    <p></p>
  </div>
</template>
<script>
export default {
  name: 'tCopyright',
  data() {
    return {};
  },
  mounted: function () {},
  methods: {},
};

</script>
<style lang="scss">
.copyright {
  text-align: center;
  padding: 0.2rem 0 0.16rem 0;
  p {
    font-size: 0.12rem;
    color: #999;
    line-height: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom/copyright.vue